module.exports = __webpack_public_path__ + "img/1493849272.a547b3e4.jpg";